module.exports = __webpack_public_path__ + "img/lock-icon.3710461e.svg";